// src/pages/admin/migrar-nuevos-miembros.tsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, doc, getDoc, query, where, serverTimestamp } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { db, secondaryAuth } from '../../firebaseConfig';
import { useUser } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

// Interfaz para los nuevos miembros
interface NuevoMiembro {
  nombre: string;
  tipo: 'Asociado' | 'Afiliado';
  agencia: string;
  correo: string;
  telefono: string;
}

// Lista de los 67 nuevos miembros de Noviembre 2025 - DATOS EXTRAÍDOS DEL EXCEL
// NOTA: Los nombres de agencias están corregidos para coincidir con Firestore
const NUEVOS_MIEMBROS: NuevoMiembro[] = [
  { nombre: 'Maria Fernanda Peregrina Acosta', tipo: 'Asociado', agencia: 'Enlace Comercial Inmobiliario', correo: 'contacto@enlacecomercialinmobiliario.com', telefono: '322-135-7348' },
  { nombre: 'Roberto García Rojas', tipo: 'Asociado', agencia: 'Roberto García Rojas', correo: 'roberto_gr2006@yahoo.com', telefono: '322-292-0391' },
  { nombre: 'Omar Aldair Flores Téllez', tipo: 'Afiliado', agencia: 'ULYSSES PROPERTIES S. DE R.L. DE C.V.', correo: 'aldair_ventas@hotmail.com', telefono: '322-134-2285' },
  { nombre: 'Joshua Gardetto', tipo: 'Afiliado', agencia: 'Mexpat Realtors', correo: 'joshua@mexpatrealtors.com', telefono: '311-149-2928' },
  { nombre: 'Diego Alejandro Bernal López', tipo: 'Afiliado', agencia: 'Mexpat Realtors', correo: 'diegoblopez@mexpatrealtors.com', telefono: '322-309-7862' },
  { nombre: 'Luis Carlos Castillón Ruíz', tipo: 'Afiliado', agencia: 'Poncho Davalos Real Estate Your Realtor For Life', correo: 'realtor.carlos.ruiz@gmail.com', telefono: '322-124-7360' },
  { nombre: 'Mauricio Ojeda', tipo: 'Afiliado', agencia: 'Poncho Davalos Real Estate Your Realtor For Life', correo: 'mauricio@ponchodavalos.com.mx', telefono: '938-128-8203' },
  { nombre: 'Jocelyn Magaña', tipo: 'Afiliado', agencia: 'Kara Realtors Excellence In Every Listing', correo: 'jocelyn@kararealtors.com', telefono: '474-110-7896' },
  { nombre: 'Dulce Denisse Fregoso', tipo: 'Afiliado', agencia: 'Kara Realtors Excellence In Every Listing', correo: 'dulce@kararealtors.com', telefono: '322-230-9957' },
  { nombre: 'Oscar Castellanos', tipo: 'Afiliado', agencia: 'Donner & Asociados', correo: 'gabana52@me.com', telefono: '322-352-6734' },
  { nombre: 'Gabriel González', tipo: 'Asociado', agencia: 'Moobi Pvr', correo: 'direccion@moobi.mx', telefono: '333-369-3878' },
  { nombre: 'María del Carmen de Pablo Albuera', tipo: 'Asociado', agencia: 'Paradise Ocean Properties', correo: 'macarmendepablo@yahoo.com.mx', telefono: '322-292-0442' },
  { nombre: 'Ana Eugenia de la Peña Contreras', tipo: 'Asociado', agencia: 'Paradise Ocean Properties', correo: 'anaben63@hotmail.com', telefono: '' },
  { nombre: 'Miriam González', tipo: 'Asociado', agencia: 'Gugo Real Estate Puerto Vallarta', correo: 'miriam@gugorealestate.com', telefono: '322-106-0896' },
  { nombre: 'Cesar López', tipo: 'Asociado', agencia: 'Discovery Vallarta Properties', correo: 'realty@discover-mx.com', telefono: '322-108-3151' },
  { nombre: 'Ana Delia Pelayo', tipo: 'Asociado', agencia: 'Re Max Kaizen', correo: 'anadelia@remax-kaizen.mx', telefono: '322-135-9813' },
  { nombre: 'Irma Leticia García', tipo: 'Asociado', agencia: 'Properties Vallarta', correo: 'lety@propertiespv.com', telefono: '322-151-0413' },
  { nombre: 'Maria Eugenia De la Peña Michel', tipo: 'Afiliado', agencia: 'Realea', correo: 'maru.dlpm@gmail.com', telefono: '322-306-0100' },
  { nombre: 'Anthony Legaré', tipo: 'Afiliado', agencia: 'Sirel Real Estate', correo: 'anthony.lb@hotmail.com', telefono: '' },
  { nombre: 'Francisco Javier Rodríguez', tipo: 'Asociado', agencia: 'Sol y Luna Realty', correo: 'javier@solylunarealty.com', telefono: '322-779-7545' },
  { nombre: 'Edgar Francisco Rodríguez Ramírez', tipo: 'Afiliado', agencia: 'Sol y Luna Realty', correo: 'edgar@solylunarealty.com', telefono: '331-601-5436' },
  { nombre: 'Esteban Hermosillo Martínez', tipo: 'Afiliado', agencia: 'North Shore Realty San Pancho', correo: 'esteban@nsrsanpancho.com', telefono: '333-350-9558' },
  { nombre: 'Luis Miguel Sandoval Torres', tipo: 'Asociado', agencia: 'Easy Home Vallarta', correo: 'luis@easyhomevallarta.com', telefono: '322-106-9911' },
  { nombre: 'Carlos Arturo Ramírez', tipo: 'Afiliado', agencia: 'Lloyd Real Estate', correo: 'carlosarturo.ramirez@live.com', telefono: '' },
  { nombre: 'Isabel Vázquez', tipo: 'Asociado', agencia: 'Green Realty Mexico', correo: 'isabel@greenrealtymexico.com', telefono: '322-429-8139' },
  { nombre: 'Donna Halcione', tipo: 'Afiliado', agencia: 'NUHome Mexico', correo: 'drhalcione@gmail.com', telefono: '322-101-1829' },
  { nombre: 'Judith Rivera Soberanis', tipo: 'Afiliado', agencia: 'Lemmus Real Estate', correo: 'judithrivera.lemmusre@gmail.com', telefono: '322-278-7123' },
  { nombre: 'Susana Padilla', tipo: 'Afiliado', agencia: 'DOMUS Fine Real Estate', correo: 'susana@domusvallarta.com', telefono: '322-182-2101' },
  { nombre: 'Carlos Alberto Murillo Tepepa', tipo: 'Afiliado', agencia: 'DOMUS Fine Real Estate', correo: 'carlos.murillo@domusvallarta.com', telefono: '' },
  { nombre: 'Kevin Andres Sanchez Zepeda', tipo: 'Afiliado', agencia: 'G&G Real Estate', correo: 'kasz2310@gmail.com', telefono: '322-121-8483' },
  { nombre: 'Adam Kieu', tipo: 'Afiliado', agencia: 'G&G Real Estate', correo: 'adam.kieu@ggpvr.com', telefono: '' },
  { nombre: 'Ana Paula Echegoyen', tipo: 'Afiliado', agencia: 'G&G Real Estate', correo: 'ana_echegoyen@gmail.com', telefono: '322-183-0768' },
  { nombre: 'Ulises Raul Pena', tipo: 'Afiliado', agencia: 'G&G Real Estate', correo: 'ulisespena90@gmail.com', telefono: '831-346-8419' },
  { nombre: 'Gabriel Alonso García Bobadilla', tipo: 'Asociado', agencia: 'Re Max On The Bay', correo: 'gabriel@remaxpuertovallarta.com', telefono: '322-136-4476' },
  { nombre: 'Javier Peñuñuri Silva', tipo: 'Afiliado', agencia: 'Re Max On The Bay', correo: 'javiersilva.realtor@gmail.com', telefono: '602-705-5695' },
  { nombre: 'Bryan Montgomery', tipo: 'Afiliado', agencia: 'Re Max On The Bay', correo: 'bryan@remaxlaplaycruz.com', telefono: '322-210-6072' },
  { nombre: 'Cameron Fitzgerald', tipo: 'Afiliado', agencia: 'Re Max On The Bay', correo: 'cameron.fitzgerald@yahoo.com', telefono: '322-132-9686' },
  { nombre: 'Fabien Antoine Francois Madesclaire', tipo: 'Afiliado', agencia: 'SB Realtors', correo: 'antonio@sbrealtors.mx', telefono: '322-117-6920' },
  { nombre: 'Richard Shea', tipo: 'Afiliado', agencia: 'Keller Williams Bahia', correo: 'rshea@kwmexico.mx', telefono: '760-699-2747' },
  { nombre: 'James Manuel Walker Jr', tipo: 'Afiliado', agencia: 'Keller Williams Bahia', correo: 'james.walker@kwmexico.mx', telefono: '' },
  { nombre: 'Jorge Antonio Ortíz Monteon', tipo: 'Afiliado', agencia: 'Century 21 Ibarria Realtors', correo: 'jorge.ortiz@c21ibarriarealtors.mx', telefono: '322-147-2972' },
  { nombre: 'Ana Escobar-Girdner', tipo: 'Afiliado', agencia: 'North Shore Realty', correo: 'ana@northshorerealty.com', telefono: '322-104-4684' },
  { nombre: 'Alfonso Vega', tipo: 'Asociado', agencia: 'Homia', correo: 'avega@homia.mx', telefono: '331-599-6031' },
  { nombre: 'Verónica Zulema García Mejía', tipo: 'Afiliado', agencia: 'BDB Realty', correo: 'vzulema1975@gmail.com', telefono: '322-168-2644' },
  { nombre: 'Carlos González Hernandez', tipo: 'Asociado', agencia: 'Your Future Home International', correo: 'car1hdezcar1hdez@gmail.com', telefono: '322-289-8261' },
  { nombre: 'Louis Wesley Cole', tipo: 'Afiliado', agencia: 'Your Future Home International', correo: 'wesleycole760@gmail.com', telefono: '(760) 219-5406' },
  { nombre: 'Diego Said Anaya Mancilla', tipo: 'Asociado', agencia: 'Century 21 CAM Grupo', correo: 'diego@camgrupo.com', telefono: '322-111-7595' },
  { nombre: 'Iliana Hernández', tipo: 'Afiliado', agencia: 'Century 21 CAM Grupo', correo: 'iliana.hernandez@c21camgrupo.com', telefono: '322-157-4369' },
  { nombre: 'Daniel de Gandiaga', tipo: 'Asociado', agencia: 'Daniel de Gandiaga Realtor', correo: 'daniel02_2697@hotmail.com', telefono: '311-111-1195' },
  { nombre: 'Claudio Arroyo Echeverry', tipo: 'Asociado', agencia: 'Ojo de Agua Real Estate Group', correo: 'claudiopropiedadmx@gmail.com', telefono: '331-208-2823' },
  { nombre: 'María Silva González', tipo: 'Asociado', agencia: 'Pacific Bay Group', correo: 'maria@pacificbaygroup.com', telefono: '322-104-7685' },
  { nombre: 'Sergio Santiago Monroy', tipo: 'Asociado', agencia: 'Santiago Realtors', correo: 'santiago@santiagorealtors.com', telefono: '322-227-6327' },
  { nombre: 'Manuel Mora Montaño', tipo: 'Asociado', agencia: 'Terra Magna Real Estate', correo: 'manuel.mora.mm@gmail.com', telefono: '322-145-7433' },
  { nombre: 'Andrea Pardio Rios', tipo: 'Asociado', agencia: 'Andrea Pardio Realty', correo: 'andreapardiorios@gmail.com', telefono: '' },
  { nombre: 'Tania Montero López', tipo: 'Asociado', agencia: 'Tania Montero', correo: 'montero_tania@hotmail.com', telefono: '322-135-8845' },
  { nombre: 'Jesús Gastelum', tipo: 'Asociado', agencia: 'eXp Realty México', correo: 'chuy.gastelum@exprealty.net', telefono: '55-6827-8382' },
  { nombre: 'Emilia Videgaray', tipo: 'Afiliado', agencia: 'eXp Realty México', correo: 'emilia@emiliavidegaray.com', telefono: '55-5418-0587' },
  { nombre: 'Sayuri Ferral López', tipo: 'Asociado', agencia: 'HIR Casa', correo: 'sferral@sucursaleshircasa.com', telefono: '449-109-6417' },
  { nombre: 'Leticia Araiza', tipo: 'Asociado', agencia: 'Vida Vallarta Real Estate', correo: 'leticia_vidahogar@hotmail.com', telefono: '322-109-9216' },
  { nombre: 'Octavio Mungía', tipo: 'Asociado', agencia: 'Destino Rentals', correo: 'octavio@destinorentals.com', telefono: '322-135-0256' },
  { nombre: 'Gabriel Zamorano Higuera', tipo: 'Asociado', agencia: 'Services Vallarta Real Estate', correo: 'servicesvallarta@gmail.com', telefono: '322-227-1698' },
  { nombre: 'Diana Jiménez', tipo: 'Asociado', agencia: 'Coastal Living Properties', correo: 'diana@coastalliving.com.mx', telefono: '322-151-1382' },
  { nombre: 'Jose Antonio Perea Contreras', tipo: 'Asociado', agencia: 'Inicio Real Estate', correo: 'japerea@iniciorealestate.com', telefono: '322-135-4224' },
  { nombre: 'Benjamín Sanchez Vizcarra', tipo: 'Asociado', agencia: 'Condominios en Puerto Vallarta', correo: 'benjamin.sanchez.pv@gmail.com', telefono: '322-121-4016' },
  { nombre: 'Esperanza Amada Luna Hernández', tipo: 'Afiliado', agencia: 'Condominios en Puerto Vallarta', correo: 'esperanza.luna.pv@gmail.com', telefono: '322-104-4297' },
  { nombre: 'Valeria Guadalupe González Jaime', tipo: 'Asociado', agencia: 'Promotora de Desarollo Jarso', correo: 'valeriagjaime14@gmail.com', telefono: '322-107-4063' },
  { nombre: 'Tannia Samperio Ortega', tipo: 'Asociado', agencia: 'Samperio Realty', correo: 'tannia.samperio@hotmail.com', telefono: '322-121-0135' },
];

interface Inmobiliaria {
  id: string;
  nombre: string;
}

interface ResultadoMigracion {
  miembro: NuevoMiembro;
  exito: boolean;
  mensaje: string;
  authCreado?: boolean;
  firestoreCreado?: boolean;
}

// Función para normalizar texto para comparación
const normalizar = (texto: string): string => {
  return texto
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

// Función para generar contraseña temporal
// Sprint 0 (F5E-005): reemplazado password hardcoded por generador aleatorio seguro.
// Cada usuario obtiene un password único; debe ser cambiado en el primer login.
const generarPasswordTemporal = (): string => {
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const lower = 'abcdefghijkmnopqrstuvwxyz';
  const digits = '23456789';
  const symbols = '!@#$%&*?';
  const all = upper + lower + digits + symbols;

  const crypto = (window.crypto || (window as any).msCrypto) as Crypto;
  const rand = (n: number) => {
    const buf = new Uint32Array(1);
    crypto.getRandomValues(buf);
    return buf[0] % n;
  };

  // Garantizar al menos 1 de cada categoría + 12 caracteres aleatorios totales.
  const required = [
    upper[rand(upper.length)],
    lower[rand(lower.length)],
    digits[rand(digits.length)],
    symbols[rand(symbols.length)],
  ];
  const fill = Array.from({ length: 12 }, () => all[rand(all.length)]);
  const combined = [...required, ...fill];
  // Shuffle (Fisher-Yates con RNG criptográfico)
  for (let i = combined.length - 1; i > 0; i--) {
    const j = rand(i + 1);
    [combined[i], combined[j]] = [combined[j], combined[i]];
  }
  return combined.join('');
};

// Generar ID único para miembro
const generarID = (nombre: string, tipo: string): string => {
  const nombres = nombre.trim().split(/\s+/).slice(0, 3).map(n => n.slice(0, 5).toLowerCase());
  const iniciales = nombres.map(n => n[0]).join('');
  const tipoPrefix = tipo === 'Asociado' ? 'aso' : 'afi';
  const random = Math.floor(100 + Math.random() * 900).toString();
  return `${tipoPrefix}${iniciales}${random}`.slice(0, 10);
};

export default function MigrarNuevosMiembros() {
  const { user, loading } = useUser();
  const navigate = useNavigate();

  const [inmobiliarias, setInmobiliarias] = useState<Inmobiliaria[]>([]);
  const [miembros, setMiembros] = useState<NuevoMiembro[]>(NUEVOS_MIEMBROS);
  const [miembrosEditados, setMiembrosEditados] = useState<NuevoMiembro[]>([]);
  const [cargando, setCargando] = useState(true);
  const [migrando, setMigrando] = useState(false);
  const [progreso, setProgreso] = useState({ actual: 0, total: 0 });
  const [resultados, setResultados] = useState<ResultadoMigracion[]>([]);
  const [mostrarJSON, setMostrarJSON] = useState(false);
  const [jsonInput, setJsonInput] = useState('');

  useEffect(() => {
    if (!loading && (!user || user.rol !== 'ADMIN')) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        // Cargar inmobiliarias
        const snapshot = await getDocs(collection(db, 'inmobiliaria'));
        const datos: Inmobiliaria[] = snapshot.docs.map(doc => ({
          id: doc.id,
          nombre: doc.data().nombre || ''
        }));
        setInmobiliarias(datos);
        setMiembrosEditados([...miembros]);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      } finally {
        setCargando(false);
      }
    };

    if (user?.rol === 'ADMIN') {
      cargarDatos();
    }
  }, [user, miembros]);

  // Buscar inmobiliaria por nombre (con normalización)
  const buscarInmobiliaria = (nombreAgencia: string): Inmobiliaria | undefined => {
    const normalizado = normalizar(nombreAgencia);
    return inmobiliarias.find(inmo => normalizar(inmo.nombre) === normalizado);
  };

  // Actualizar miembro en la lista
  const actualizarMiembro = (index: number, campo: keyof NuevoMiembro, valor: string) => {
    const nuevaLista = [...miembrosEditados];
    nuevaLista[index] = { ...nuevaLista[index], [campo]: valor };
    setMiembrosEditados(nuevaLista);
  };

  // Cargar datos desde JSON
  const cargarDesdeJSON = () => {
    try {
      const datos = JSON.parse(jsonInput);
      if (Array.isArray(datos)) {
        setMiembrosEditados(datos);
        setMostrarJSON(false);
        Swal.fire({
          icon: 'success',
          title: 'Datos cargados',
          text: `Se cargaron ${datos.length} miembros desde JSON`,
          confirmButtonColor: '#0c2339'
        });
      } else {
        throw new Error('El JSON debe ser un array');
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Error en JSON',
        text: error.message,
        confirmButtonColor: '#d33'
      });
    }
  };

  // Exportar plantilla JSON
  const exportarPlantilla = () => {
    const plantilla = miembrosEditados.map(m => ({
      nombre: m.nombre,
      tipo: m.tipo,
      agencia: m.agencia,
      correo: m.correo || 'COMPLETAR@email.com',
      telefono: m.telefono || '3221234567'
    }));
    const blob = new Blob([JSON.stringify(plantilla, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'plantilla-miembros-nov2025.json';
    a.click();
  };

  // Verificar que todos los miembros tengan datos completos
  const validarDatos = (): { valido: boolean; errores: string[] } => {
    const errores: string[] = [];
    miembrosEditados.forEach((m, idx) => {
      if (!m.correo || !m.correo.includes('@')) {
        errores.push(`#${idx + 1} ${m.nombre}: Correo inválido o vacío`);
      }
      // Teléfono es opcional ahora
      const inmo = buscarInmobiliaria(m.agencia);
      if (!inmo) {
        errores.push(`#${idx + 1} ${m.nombre}: Inmobiliaria "${m.agencia}" no encontrada`);
      }
    });
    return { valido: errores.length === 0, errores };
  };

  // Migrar todos los miembros
  const migrarMiembros = async () => {
    const validacion = validarDatos();
    if (!validacion.valido) {
      Swal.fire({
        icon: 'error',
        title: 'Datos incompletos',
        html: `<div style="text-align:left; max-height:300px; overflow-y:auto;">
          ${validacion.errores.slice(0, 10).map(e => `<p>• ${e}</p>`).join('')}
          ${validacion.errores.length > 10 ? `<p><strong>...y ${validacion.errores.length - 10} errores más</strong></p>` : ''}
        </div>`,
        confirmButtonColor: '#d33'
      });
      return;
    }

    const confirmacion = await Swal.fire({
      title: '¿Iniciar migración?',
      html: `Se crearán <strong>${miembrosEditados.length}</strong> nuevos miembros.<br><br>
             <small>Esto incluye crear cuentas de Firebase Auth y documentos en Firestore.</small>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, migrar todos',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0c2339'
    });

    if (!confirmacion.isConfirmed) return;

    setMigrando(true);
    setProgreso({ actual: 0, total: miembrosEditados.length });
    const resultadosMigracion: ResultadoMigracion[] = [];

    for (let i = 0; i < miembrosEditados.length; i++) {
      const miembro = miembrosEditados[i];
      const resultado: ResultadoMigracion = {
        miembro,
        exito: false,
        mensaje: '',
        authCreado: false,
        firestoreCreado: false
      };

      try {
        // 1. Verificar si el correo ya existe en Firestore
        const coleccion = miembro.tipo === 'Asociado' ? 'asociado' : 'asesor';
        const qExistente = query(collection(db, coleccion), where('correo', '==', miembro.correo.toLowerCase()));
        const existente = await getDocs(qExistente);

        if (!existente.empty) {
          resultado.mensaje = 'Ya existe un miembro con este correo';
          resultadosMigracion.push(resultado);
          setProgreso({ actual: i + 1, total: miembrosEditados.length });
          continue;
        }

        // 2. Buscar inmobiliaria
        const inmobiliaria = buscarInmobiliaria(miembro.agencia);
        if (!inmobiliaria) {
          resultado.mensaje = `Inmobiliaria "${miembro.agencia}" no encontrada`;
          resultadosMigracion.push(resultado);
          setProgreso({ actual: i + 1, total: miembrosEditados.length });
          continue;
        }

        // 3. Generar contraseña temporal
        const passwordTemporal = generarPasswordTemporal();

        // 4. Crear cuenta en Firebase Auth
        try {
          await createUserWithEmailAndPassword(secondaryAuth, miembro.correo.toLowerCase(), passwordTemporal);
          resultado.authCreado = true;
        } catch (authError: any) {
          if (authError.code === 'auth/email-already-in-use') {
            resultado.authCreado = true; // La cuenta ya existe, continuar
          } else {
            throw authError;
          }
        }

        // 5. Generar ID único
        const miembroId = generarID(miembro.nombre, miembro.tipo);

        // 6. Crear documento en Firestore
        const nuevoMiembro = miembro.tipo === 'Asociado' ? {
          tipo: 'asociado',
          asociado_id: miembroId,
          nombre: miembro.nombre,
          biografia: '',
          telefono: miembro.telefono,
          correo: miembro.correo.toLowerCase(),
          inmobiliaria_doc_ids: [inmobiliaria.id],
          anos_experiencia: 0,
          redes: { facebook: '', instagram: '' },
          foto: '',
          certificaciones: [],
          calificacion: 0,
          activo: true,
          creadoDesde: 'migracion-nov-2025',
          createdAt: serverTimestamp()
        } : {
          tipo: 'asesor',
          asesor_id: miembroId,
          nombre: miembro.nombre,
          biografia: '',
          telefono: miembro.telefono,
          correo: miembro.correo.toLowerCase(),
          inmobiliaria_doc_ids: [inmobiliaria.id],
          anos_experiencia: 0,
          redes: { facebook: '', instagram: '' },
          foto: '',
          certificaciones: [],
          calificacion: 0,
          activo: true,
          creadoDesde: 'migracion-nov-2025',
          createdAt: serverTimestamp()
        };

        await addDoc(collection(db, coleccion), nuevoMiembro);
        resultado.firestoreCreado = true;

        // 7. Actualizar inmobiliaria con el nuevo miembro
        const inmobiliariaRef = doc(db, 'inmobiliaria', inmobiliaria.id);
        const inmobiliariaSnap = await getDoc(inmobiliariaRef);
        if (inmobiliariaSnap.exists()) {
          const campo = miembro.tipo === 'Asociado' ? 'asociado_id' : 'asesor_id';
          const existingIds = inmobiliariaSnap.data()[campo] || [];
          const actualizado = Array.from(new Set([...existingIds, miembroId]));
          await updateDoc(inmobiliariaRef, { [campo]: actualizado });
        }

        resultado.exito = true;
        resultado.mensaje = `Creado exitosamente (Password: ${passwordTemporal})`;

      } catch (error: any) {
        resultado.mensaje = error.message || 'Error desconocido';
      }

      resultadosMigracion.push(resultado);
      setProgreso({ actual: i + 1, total: miembrosEditados.length });
    }

    setResultados(resultadosMigracion);
    setMigrando(false);

    const exitosos = resultadosMigracion.filter(r => r.exito).length;
    const fallidos = resultadosMigracion.filter(r => !r.exito).length;

    Swal.fire({
      icon: exitosos > 0 ? 'success' : 'error',
      title: 'Migración completada',
      html: `<strong>${exitosos}</strong> miembros creados exitosamente.<br>
             <strong>${fallidos}</strong> fallidos o ya existentes.`,
      confirmButtonColor: '#0c2339'
    });
  };

  if (loading || cargando) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const miembrosConDatos = miembrosEditados.filter(m => m.correo).length;
  const miembrosSinDatos = miembrosEditados.filter(m => !m.correo).length;
  const asociados = miembrosEditados.filter(m => m.tipo === 'Asociado').length;
  const afiliados = miembrosEditados.filter(m => m.tipo === 'Afiliado').length;

  return (
    <div style={{ padding: '20px', maxWidth: '1600px', margin: '0 auto' }}>
      <h1>Migración de Nuevos Miembros - Nov 2025</h1>
      <p className="text-muted">Herramienta para dar de alta los 67 nuevos miembros de AMPI</p>

      {/* Resumen */}
      <div className="row g-3 mb-4">
        <div className="col-md-2">
          <div className="card bg-primary text-white">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{miembrosEditados.length}</h4>
              <small>Total</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-success text-white">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{miembrosConDatos}</h4>
              <small>Con datos</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-warning">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{miembrosSinDatos}</h4>
              <small>Sin datos</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-info text-white">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{asociados}</h4>
              <small>Asociados</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-secondary text-white">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{afiliados}</h4>
              <small>Afiliados</small>
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="card bg-dark text-white">
            <div className="card-body text-center py-2">
              <h4 className="mb-0">{inmobiliarias.length}</h4>
              <small>Inmobiliarias</small>
            </div>
          </div>
        </div>
      </div>

      {/* Botones de acción */}
      <div className="mb-4">
        <button className="btn btn-outline-primary me-2" onClick={exportarPlantilla}>
          <i className="fa-solid fa-download me-2"></i>
          Exportar Plantilla JSON
        </button>
        <button className="btn btn-outline-secondary me-2" onClick={() => setMostrarJSON(!mostrarJSON)}>
          <i className="fa-solid fa-code me-2"></i>
          {mostrarJSON ? 'Ocultar JSON' : 'Importar desde JSON'}
        </button>
        <button
          className="btn btn-success"
          onClick={migrarMiembros}
          disabled={migrando || miembrosSinDatos > 0}
        >
          {migrando ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Migrando {progreso.actual}/{progreso.total}...
            </>
          ) : (
            <>
              <i className="fa-solid fa-user-plus me-2"></i>
              Migrar Todos los Miembros
            </>
          )}
        </button>
      </div>

      {/* Área de JSON */}
      {mostrarJSON && (
        <div className="card mb-4">
          <div className="card-header">
            <h5 className="mb-0">Importar datos desde JSON</h5>
          </div>
          <div className="card-body">
            <p className="text-muted small">
              Pega aquí el JSON con los datos de los miembros. Debe ser un array con objetos que contengan:
              nombre, tipo, agencia, correo, telefono
            </p>
            <textarea
              className="form-control mb-3"
              rows={10}
              value={jsonInput}
              onChange={(e) => setJsonInput(e.target.value)}
              placeholder='[{"nombre": "...", "tipo": "Asociado", "agencia": "...", "correo": "...", "telefono": "..."}]'
            />
            <button className="btn btn-primary" onClick={cargarDesdeJSON}>
              <i className="fa-solid fa-upload me-2"></i>
              Cargar datos
            </button>
          </div>
        </div>
      )}

      {/* Barra de progreso */}
      {migrando && (
        <div className="progress mb-4" style={{ height: '25px' }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            style={{ width: `${(progreso.actual / progreso.total) * 100}%` }}
          >
            {progreso.actual}/{progreso.total} miembros procesados
          </div>
        </div>
      )}

      {/* Tabla de miembros */}
      <div className="table-responsive">
        <table aria-label="Tabla de Migrar Nuevos Miembros" className="table table-sm table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th style={{ width: '30px' }}>#</th>
              <th scope="col">Nombre</th>
              <th style={{ width: '100px' }}>Tipo</th>
              <th scope="col">Agencia</th>
              <th scope="col">Correo</th>
              <th scope="col">Teléfono</th>
              <th style={{ width: '80px' }}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {miembrosEditados.map((m, idx) => {
              const inmoEncontrada = buscarInmobiliaria(m.agencia);
              const resultado = resultados.find(r => r.miembro.correo === m.correo);

              return (
                <tr key={idx} className={resultado ? (resultado.exito ? 'table-success' : 'table-danger') : ''}>
                  <td>{idx + 1}</td>
                  <td><small>{m.nombre}</small></td>
                  <td>
                    <span className={`badge ${m.tipo === 'Asociado' ? 'bg-info' : 'bg-secondary'}`}>
                      {m.tipo}
                    </span>
                  </td>
                  <td>
                    <small className={inmoEncontrada ? 'text-success' : 'text-danger'}>
                      {inmoEncontrada ? '✓ ' : '✗ '}
                      {m.agencia}
                    </small>
                  </td>
                  <td>
                    <input
                      type="email"
                      className={`form-control form-control-sm ${!m.correo ? 'border-warning' : ''}`}
                      value={m.correo}
                      onChange={(e) => actualizarMiembro(idx, 'correo', e.target.value)}
                      placeholder="correo@ejemplo.com"
                      disabled={migrando}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${!m.telefono ? 'border-warning' : ''}`}
                      value={m.telefono}
                      onChange={(e) => actualizarMiembro(idx, 'telefono', e.target.value)}
                      placeholder="3221234567"
                      disabled={migrando}
                    />
                  </td>
                  <td>
                    {resultado ? (
                      resultado.exito ? (
                        <span className="badge bg-success">OK</span>
                      ) : (
                        <span className="badge bg-danger" title={resultado.mensaje}>Error</span>
                      )
                    ) : (
                      m.correo ? (
                        <span className="badge bg-secondary">Pendiente</span>
                      ) : (
                        <span className="badge bg-warning text-dark">Sin correo</span>
                      )
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Resultados de migración */}
      {resultados.length > 0 && (
        <div className="card mt-4">
          <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Resultados de Migración</h5>
            <button
              className="btn btn-light btn-sm"
              onClick={() => {
                const data = resultados.map(r => ({
                  nombre: r.miembro.nombre,
                  correo: r.miembro.correo,
                  exito: r.exito,
                  mensaje: r.mensaje
                }));
                const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'resultados-migracion.json';
                a.click();
              }}
            >
              <i className="fa-solid fa-download me-1"></i>
              Exportar
            </button>
          </div>
          <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {resultados.map((r, idx) => (
              <div key={idx} className={`alert ${r.exito ? 'alert-success' : 'alert-danger'} py-2 mb-2`}>
                <strong>#{idx + 1} {r.miembro.nombre}</strong>
                <br />
                <small>{r.mensaje}</small>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Botón volver */}
      <div className="mt-4">
        <button className="btn btn-outline-secondary" onClick={() => navigate('/dashboard')}>
          <i className="fa-solid fa-arrow-left me-2"></i>
          Volver al Dashboard
        </button>
      </div>
    </div>
  );
}
